module.exports = __webpack_public_path__ + "public/adminIcons/dashboard.svg?23edd6e1";